<template>
  <v-container
    fluid
    class="d-flex justify-space-between align-center flex-wrap px-2"
    :class="{
      'bordered-toolbar': !isNavDrawer,
      'py-3 px-4': !isVideoPage,
    }"
    v-if="isRouteAllowed"
  >
    <!-- logo -->
    <div
      class="d-flex"
      v-if="
        ((!isVideoPage && !isHoveringNavDrawer) || isHoveringNavDrawer) &&
        !!userInfo
      "
    >
      <div v-if="isMobileBreakpoint && !isNavDrawer">
        <v-row no-gutters>
          <v-btn icon @click="openDrawer" v-if="this.$route.name !== 'Cart'">
            <v-icon class="toolbarMenuIcon">mdi-menu</v-icon>
          </v-btn>
        </v-row>
      </div>
      <div
        v-if="isMobileBreakpoint && !isNavDrawer"
        class="d-flex align-center"
      >
        <img
          v-if="$vuetify.theme.dark"
          transition="false"
          @click="handleGoHome"
          :class="isNavDrawer ? 'mt-1' : ''"
          src="@/assets/pandaLogo.svg"
          style="max-width: 60px; max-height: 40px"
        />
        <img
          v-else
          transition="false"
          @click="handleGoHome"
          :class="isNavDrawer ? 'mt-1' : ''"
          src="@/assets/pandaLogo.svg"
          style="max-width: 60px; max-height: 40px"
        />
        <span class="global__currentRoute-title ml-2">{{
          currentRouteTitle
        }}</span>
      </div>
      <v-col
        cols="12"
        class="pa-0 d-flex"
        style="margin-bottom: 10px"
        v-else-if="isNavDrawer"
      >
        <v-img
          eager
          transition="false"
          v-if="$vuetify.theme.dark"
          class="ml-2 mt-3 mb-1"
          src="../assets/headerImage.svg"
          max-width="179"
        ></v-img>
        <v-img
          eager
          v-else
          transition="false"
          class="ml-2 mt-3 mb-1"
          src="../assets/newPandaLogo.svg"
        ></v-img>
      </v-col>
      <div class="pa-0 d-flex justify-center" v-else>
        <v-img
          eager
          transition="false"
          v-if="$vuetify.theme.dark"
          class="ml-2 mt-3 mb-1"
          src="../assets/headerImage.svg"
          max-width="179"
        ></v-img>
        <v-img
          eager
          transition="false"
          v-else
          class="ml-2 mt-3 mb-1"
          src="../assets/newPandaLogo.svg"
        ></v-img>
      </div>
    </div>

    <div v-if="isMobileBreakpoint && !isNavDrawer && isVideoPage">
      <v-row no-gutters>
        <v-btn icon @click="openDrawerVideoPage">
          <v-icon class="toolbarMenuIcon">mdi-menu</v-icon>
        </v-btn>
      </v-row>
    </div>
    <div
      v-if="isVideoPage && !isHoveringNavDrawer && !!userInfo"
      style="margin: 0 auto; padding-bottom: 14px"
      class="pt-3"
    >
      <v-img
        eager
        transition="false"
        src="@/assets/pandaLogoUnique.svg"
      ></v-img>
    </div>
    <!-- email::dropmenu -->
    <v-menu
      v-model="mainMenu"
      offset-y
      :nudge-width="80"
      :close-on-content-click="false"
      v-if="!!userInfo"
      style="z-index: 99999 !important"
    >
      <template v-slot:activator="{ on }">
        <v-list
          nav
          class="pa-0 activeToolbarBorder selectProfile"
          :class="{ 'mb-3': isNavDrawer }"
          :style="isNavDrawer ? 'width: 100%; max-width: 100%;' : ''"
        >
          <v-list-item-group
            color="primary"
            v-if="!(isMobileBreakpoint && !isNavDrawer)"
          >
            <v-list-item
              class="always-active-list-item"
              :class="{
                'always-active-list-item--dark': $vuetify.theme.dark,
                activeToolbarBorder: mainMenu,
              }"
              v-on="on"
            >
              <v-list-item-icon class="mr-3">
                <v-avatar color="#3F55EE" size="24">
                  <v-img
                    v-if="userAllInfo && userAllInfo.image_path"
                    :src="userAllInfo.image_path"
                    :alt="userAllInfo.name"
                  ></v-img>
                  <span v-else class="white--text avatarText">
                    {{ userNameProfileInitials }}
                  </span>
                </v-avatar>
              </v-list-item-icon>
              <v-list-item-content>
                <!-- Get user by id name -->
                <v-list-item-title
                  style="z-index: 1; font-size: 14px"
                  class="textType6--text"
                >
                  {{ userLabelName }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon size="16" color="#8F92A3">panda-chev-down</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
          <v-avatar
            v-else
            color="#A0ACFF"
            size="24"
            v-on="on"
            @click="mainMenu = !mainMenu"
          >
            <span class="white--text avatarText">{{ userNameInitials }}</span>
          </v-avatar>
        </v-list>
      </template>
      <v-list dense class="pt-0">
        <v-list-item
          class="py-0"
          style="max-width: 400px; min-height: 60px !important"
        >
          <v-row
            no-gutters
            justify="center"
            class="flex-column my-4"
            align="center"
            style="margin-bottom: 1px solid #edeef1"
          >
            <v-avatar color="#0F22A1" size="48" class="mb-4">
              <v-img
                v-if="userAllInfo && userAllInfo.image_path"
                :src="userAllInfo.image_path"
                :alt="userAllInfo.name"
              ></v-img>
              <span v-else class="white--text avatarText">
                {{ userNameProfileInitials }}
              </span>
            </v-avatar>
            <v-row no-gutters align="center">
              <!-- Get user by id name -->
              <span class="userNameText textType5--text">{{
                userLabelName
              }}</span>
              <v-card color="#EDEEF1" class="rounded-pill px-1 ml-2" flat>
                <span class="text--center roleText">
                  <span>
                    {{
                      capitalizeFirstLetter(
                        this.$store.state.user.userAllInfo.role_name
                      )
                    }}
                  </span>
                </span>
              </v-card>
            </v-row>
            <span class="emailSubtitleText textType4--text mt-1">{{
              userAllInfo.email
            }}</span>
            <span
              @click="handleSeeProfile"
              style="cursor: pointer"
              class="profileBtn primary--text mt-1"
              >{{ $t('message.navDrawer.myProfile.button') }}</span
            >
          </v-row>
        </v-list-item>
        <v-col cols="12" class="pa-0">
          <v-divider />
        </v-col>
        <v-list-item dense class="py-2">
          <v-list-item-avatar
            class="d-flex flex-row align-center justify-center"
          >
            <v-card
              class="elevation-0 d-flex flex-row align-center justify-center"
              style="border-radius: 32px; height: 20px; width: 20px"
              color="#EDEEF1"
            >
              <simple-svg
                :src="require('@/assets/panda_org_icon.svg')"
                fill-class-name="fill-color"
                :fill="$vuetify.theme.dark ? 'white' : '#3F404C'"
              />
            </v-card>
          </v-list-item-avatar>
          <v-list-item-content class="container-ellipsis">
            <v-list-item-title>
              <span :title="organization.name" class="ellipsis-text"
                >{{ organization.name }}
              </span>
            </v-list-item-title>
            <v-list-item-subtitle>{{
              $t('message.navDrawer.myProfile.myOrg')
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-col cols="12" class="pa-0">
          <v-divider />
        </v-col>
        <v-menu offset-x right transition="slide-x-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item
              v-bind="attrs"
              v-on="on"
              dense
              class="py-0 smallItem"
              @click="handleAffiliates"
            >
              <v-list-item-avatar
                class="d-flex flex-row align-center justify-center"
              >
                <simple-svg
                  :src="require('@/assets/panda_afilliate_icon.svg')"
                  fill-class-name="fill-color"
                  :fill="$vuetify.theme.dark ? 'white' : '#3F404C'"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{
                  $t('message.affiliate')
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-menu>
        <v-col cols="12" class="pa-0">
          <v-divider />
        </v-col>
        <v-menu offset-x right transition="slide-x-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on" dense class="py-0 smallItem">
              <v-list-item-avatar>
                <v-icon size="20px" color="#3F404C">mdi-translate</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{
                  $i18next.t('message.language')
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon size="20px" color="grey lighten-1"
                  >mdi-chevron-right</v-icon
                >
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item
              v-for="language in languages"
              dense
              @click="handleLanguage(language)"
              :key="language.text"
              class="py-0 smallItem"
            >
              <v-list-item-avatar>
                <v-icon size="20px" v-if="returnLanguage === language.value">
                  mdi-check
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-title class="px-2">
                {{ language.text }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-x right transition="slide-x-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on" dense class="py-0 smallItem">
              <v-list-item-avatar
                class="d-flex flex-row align-center justify-center"
              >
                <simple-svg
                  :src="require('@/assets/panda_theme_icon.svg')"
                  fill-class-name="fill-color"
                  :fill="$vuetify.theme.dark ? 'white' : '#3F404C'"
                />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('message.pages.toolbar.theme') }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon size="20px" color="grey lighten-1">
                  mdi-chevron-right
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item
              v-for="theme in themes"
              :key="theme.value"
              @click="handleCustomTheme(theme.value)"
              dense
              class="py-0 smallItem"
            >
              <v-list-item-avatar>
                <v-icon size="20px" v-if="userSelectedTheme === theme.value">
                  mdi-check
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="theme.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-col cols="12" class="pa-0">
          <v-divider />
        </v-col>
        <v-list-item dense class="py-0 smallItem" @click="handleChat">
          <v-list-item-avatar
            class="d-flex flex-row align-center justify-center"
          >
            <simple-svg
              fill-class-name="fill-color"
              fill="var(--v-neutral-lighten2)"
              :src="require('@/assets/panda_chat_icon.svg')"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{
              $t('message.navDrawer.myProfile.startChat')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item dense class="py-0 smallItem" @click="handleHelp">
          <v-list-item-avatar
            class="d-flex flex-row align-center justify-center"
          >
            <simple-svg
              fill-class-name="fill-color"
              fill="var(--v-neutral-lighten2)"
              :src="require('@/assets/panda_help_icon.svg')"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{
              $t('message.navDrawer.myProfile.helpCentral')
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-col cols="12" class="pa-0">
          <v-divider />
        </v-col>
        <v-list-item class="py-0 smallItem" @click="handlePageStatus">
          <v-list-item-avatar
            class="d-flex flex-row align-center justify-center"
          >
            <simple-svg
              :src="require('@/assets/panda_status_icon.svg')"
              fill-class-name="fill-color"
              :fill="$vuetify.theme.dark ? 'white' : '#3F404C'"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('message.statusPage') }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="goToAccount"
          class="py-0 smallItem"
          v-if="canSeePlanInfo"
        >
          <v-list-item-avatar
            class="d-flex flex-row align-center justify-center"
          >
            <simple-svg
              :src="require('@/assets/panda_finance_icon.svg')"
              fill-class-name="fill-color"
              :fill="$vuetify.theme.dark ? 'white' : '#3F404C'"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t('message.finance') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-col cols="12" class="pa-0" v-for="item in items" :key="item.title">
          <v-divider v-if="item.val === 'signout'" />
          <v-list-item @click="item.method" dense class="py-0 smallItem">
            <v-list-item-avatar>
              <v-icon size="20px" color="#3F404C" v-text="item.icon"></v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-list>
    </v-menu>
    <div v-else-if="isNavDrawer" class="container--email-field">
      <v-skeleton-loader
        style="border-radius: 4px"
        height="26"
        :width="isVideoPage ? 24 : 108"
        type="image"
        :class="{ 'ml-3': isVideoPage }"
        class="mb-3 mx-2 mt-3"
      ></v-skeleton-loader>
      <v-skeleton-loader
        :width="isVideoPage ? 40 : 174"
        height="40"
        type="image"
        class="mb-10 mt-1"
        :class="{ 'ml-1': isVideoPage }"
      ></v-skeleton-loader>
    </div>
    <v-skeleton-loader
      v-else
      type="list-item-avatar"
      class="avatar-floating-skeleton-loader--mobile"
    ></v-skeleton-loader>
    <!-- staging badge -->
  </v-container>
</template>

<script>
import Storage from '../utils/Storage'
import {
  PANDA_HELP_LINK,
  PANDA_AFFILIATES_LINK,
  BR_PANDA_AFFILIATES_LINK,
  ENV_CONFIG,
  PANDA_STATUS_PAGE_BR,
  PANDA_STATUS_PAGE,
} from '@/config/envs.js'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
import organizationApi from '@/services/organizationApi.js'

export default {
  name: 'TheToolbar',
  props: {
    isNavDrawer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      affiliate: this.$i18next.t('message.affiliate'),
      rootMenu: false,
      filterText: '',
      mainMenu: false,
      isHoveringNavDrawer: false,
      isVideoPage: false,
      userSelectedTheme: 'device',
      themes: [],
      isBeta: false,
      organization: {
        name: '',
        image_id: '',
        image_path: '',
      },
    }
  },
  computed: {
    ...mapGetters('user', ['canSeePlanInfo']),
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
      userInfo: (state) => state.user.userPlanInfo.user,
      userAllInfo: (state) => state.user.userAllInfo,
      userPlanInfo: (state) => state.user.userPlanInfo,
    }),
    returnLanguage() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en'
      if (this.$i18next.resolvedLanguage === 'pt') return 'pt'
      return 'es'
    },
    languages() {
      return [
        { text: this.$i18next.t('message.english'), value: 'en' },
        { text: this.$i18next.t('message.portuguese'), value: 'pt' },
        {
          text: this.$i18next.t(
            'message.pages.videoEditModal.languages.spanish'
          ),
          value: 'es',
        },
      ]
    },
    organizationInitials() {
      if (this.organization.name) {
        let initials = this.organization.name
        if (initials) {
          return initials
            .match(/(^\S\S?|\s\S)?/g)
            .map((v) => v.trim())
            .join('')
            .match(/(^\S|\S$)?/g)
            .join('')
            .toLocaleUpperCase()
        }
        return initials
      }
      return 'logo'
    },
    items() {
      let arr = [
        {
          title: this.$i18next.t('message.signOut'),
          icon: 'mdi-logout',
          method: this.handleLogout,
          val: 'signout',
        },
      ]
      if (this.isRootUser.push) {
        arr.splice(0, 0, {
          title: this.$i18next.t('message.affiliates'),
          icon: '$',
          method: this.handleAffiliates,
          val: 'affiliates',
        })
      }
      return arr
    },
    isRootUser() {
      return this.$store.state.user?.userAllInfo?.is_root ?? false
    },
    userLabelName() {
      if (this.userAllInfo?.name) {
        return this.userAllInfo.name
      }
      if (this.userInfo?.name) {
        return this.userInfo.name
      } else if (this.userInfo?.email) {
        return this.userInfo.email
      }
      return ''
    },
    currentRouteTitle() {
      const i18n = this.$i18next
      const { name } = this.$route
      const routeTitle = i18n.t(`message.routesTitles.${name}`, {
        price: this.userPlanInfo?.currency == 'brl' ? 'R$150' : '$30',
      })

      if (routeTitle) return routeTitle
      return i18n.t('message.routesTitles.Videos')
    },
    userNameInitials() {
      let initials = ''
      if (this.userInfo?.name) {
        initials = this.userInfo.name
      } else if (this.userInfo?.email) {
        initials = this.userInfo.email
      }
      return initials[0]
    },
    userNameProfileInitials() {
      let initials = ''
      if (this.userAllInfo?.name) {
        initials = this.userAllInfo.name
      } else if (this.userInfo?.name) {
        initials = this.userInfo.name
      }
      return initials[0]
    },
    isProduction() {
      return ENV_CONFIG === 'production'
    },
    isRouteAllowed() {
      if (
        this.$route.name !== 'Login' &&
        this.$route.name !== 'SignUp' &&
        this.$route.name !== 'FirstLoading'
      ) {
        return true
      }
      return false
    },
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        this.checkIfIsVideoPage()
        this.isHoveringNavDrawer = false
      })
    },
  },
  async mounted() {
    this.checkIfIsVideoPage()
    this.isHoveringNavDrawer = false
    this.$root.$on('mouseEnterNavDrawer', () => {
      this.isHoveringNavDrawer = true
    })

    this.$root.$on('mouseLeaveNavDrawer', () => {
      this.isHoveringNavDrawer = false
    })

    this.isBeta = location.search.match('beta')
    this.getOrganization()
    this.setOptions()
    this.setTheme()
    this.$root.$on('toolbarEventLogout', () => {
      this.handleLogout()
    })
    this.$root.$on('updateToolbarOrganization', (orgData) => {
      this.organization = orgData
    })
  },
  methods: {
    ...mapActions('session', ['getUserDataByID']),
    ...mapMutations('user', [
      'UPDATE_DID_FETCH_VIDEOS',
      'UPDATE_USER_PLAN_INFO',
      'UPDATE_USER_ORGANIZATION',
    ]),
    checkIfIsVideoPage() {
      if (
        this.$route.name === 'VideoPage' ||
        this.$route.name === 'AgentPage' ||
        (this.$route.name.includes('AnalyticsV3') &&
          this.$route.name !== 'AnalyticsV3Resume') ||
        this.$route.name === 'DRMGroup' ||
        this.$route.name === 'FunnelPage' ||
        this.$route.name === 'VideoPageQuizCta' ||
        this.$route.name === 'VideoPageButton' ||
        this.$route.name === 'VideoPageButtonInteraction' ||
        this.$route.name === 'VideoPageForm' ||
        this.$route.name === 'VideoPageInfoBar' ||
        this.$route.name === 'VideoPageChapters' ||
        this.$route.name === 'VideoPageMiniTrigger'
      ) {
        this.isVideoPage = true
      } else {
        this.isVideoPage = false
      }
    },
    async getOrganization() {
      try {
        let ret = await organizationApi.getOrganization()
        this.UPDATE_USER_ORGANIZATION(ret.data)
        this.organization = {
          name: ret.data.name,
          image_path: ret.data.image_path ?? null,
          image_id: ret.data.image_id ?? null,
        }
      } catch (e) {
        console.log('e', e)
      }
    },
    handleSeeProfile() {
      this.$root.$emit('openMyProfileModal')
      this.mainMenu = false
    },
    openDrawer() {
      this.$root.$emit('toolbarEventOpenDrawer')
    },
    openDrawerVideoPage() {
      this.$root.$emit('toolbarEventOpenDrawerVideoPage')
    },
    setDeviceTheme() {
      const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)')
      this.userSelectedTheme = 'device'
      Storage.setItem('selectedThemeV2', 'device')
      if (darkThemeMq?.matches) {
        document.body.classList.add('bg-dark')
        this.$vuetify.theme.dark = true
      } else {
        document.body.classList.remove('bg-dark')
        this.$vuetify.theme.dark = false
        Storage.setItem('selectedThemeV2', 'light')
      }
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    setTheme() {
      const selectedTheme = Storage.getItem('selectedThemeV2')
      if (selectedTheme) {
        this.userSelectedTheme = selectedTheme
        this.handleCustomTheme(selectedTheme)
      } else {
        this.setDeviceTheme()
      }
    },
    handleCustomTheme(theme) {
      this.$root.$emit('analyticsDarkTheme')
      this.$root.$emit('abTestDarkTheme')
      this.userSelectedTheme = theme
      Storage.setItem('selectedThemeV2', theme)
      if (theme === 'dark') {
        document.body.classList.add('bg-dark')
        this.$vuetify.theme.dark = true
      } else if (theme === 'light') {
        document.body.classList.remove('bg-dark')
        this.$vuetify.theme.dark = false
      } else {
        this.setDeviceTheme()
      }
    },
    async handleLogout() {
      try {
        this.UPDATE_DID_FETCH_VIDEOS(false)
        this.setStorageConfig()
        this.UPDATE_USER_PLAN_INFO(false)
        await this.$store.dispatch('session/signOut')
        this.$router.push({ name: 'Login' })
      } catch (e) {
        console.error(e)
        this.$router.push({ name: 'Login' })
      }
    },
    setStorageConfig() {
      let StorageData = Storage.getStorageKeys()
      const lastDismissed = localStorage.getItem('2FA_modal_dismissed')
      Storage.clear()
      StorageData.map((key) => {
        const keyParameter = key[0]
        if (
          // keyParameter === 'hasClosedAiBanner' ||
          keyParameter === 'introjs-trash-selected-finished' ||
          keyParameter === 'hasClosedTrainingBanner' ||
          keyParameter === 'introjs-trash-finished' ||
          keyParameter === 'trainingBannerExpiry'
        )
          Storage.setItem(keyParameter, true)
      })
      localStorage.setItem('2FA_modal_dismissed', lastDismissed)
    },
    setOptions() {
      this.themes = [
        {
          text: this.$i18next.t('message.pages.toolbar.useDevice'),
          value: 'device',
        },
        {
          text: this.$i18next.t('message.pages.toolbar.lightTheme'),
          value: 'light',
        },
        {
          text: this.$i18next.t('message.pages.toolbar.darkTheme'),
          value: 'dark',
        },
      ]
    },
    handleLanguage(lang) {
      this.$root.$emit('isLanguageChanging', true)
      Storage.setItem('locale', lang.value)
      this.$i18next.changeLanguage(lang.value)
      this.$root.$emit('changeLanguage')
      this.$root.$emit('setUppyDashboardLanguage', lang.value)
      this.setOptions()
      setTimeout(() => {
        this.$root.$emit('isLanguageChanging', false)
      }, 1000)
    },
    handleGoHome() {
      this.$route.name !== 'Videos' && this.$router.push({ name: 'Videos' })
    },
    handleHelp() {
      this.mainMenu = false
      return window.open(`${PANDA_HELP_LINK}`, '_blank')
    },
    handlePageStatus() {
      let route = PANDA_STATUS_PAGE_BR

      if (this.$i18next.resolvedLanguage === 'en') route = PANDA_STATUS_PAGE

      this.mainMenu = false
      return window.open(route, '_blank')
    },
    handleAffiliates() {
      let route = BR_PANDA_AFFILIATES_LINK

      if (this.$i18next.resolvedLanguage === 'en') route = PANDA_AFFILIATES_LINK

      this.mainMenu = false

      return window.open(`${route}`, '_blank')
    },
    handleChat() {
      this.mainMenu = false
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
      this.$crisp.push([
        'on',
        'chat:opened',
        function () {
          // eslint-disable-next-line
          fbq('trackCustom', 'Crisp Chat Opened')
        },
      ])
    },
    goToAccount() {
      this.$router.push({ name: 'UserPlan' }).catch(() => {})
      this.mainMenu = false
    },
  },
}
</script>

<style scoped lang="scss">
.container--email-field {
  width: 100%;
  position: relative;
}

.v-img {
  transition: none !important;
  animation: none !important;
}

.v-application .primary {
  border-color: rgba(0, 0, 0, 0.12) !important;
}

.toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.staging-toolbar {
  display: flex;
  justify-content: center;
  width: 100vw;
  position: absolute;
  height: 2px;
  left: 0;
  top: 62px;
  background: #f5925e;
}
.staging-toolbar span {
  background: #f5925e;
  color: #fff;
  padding: 0 5px;
  padding-bottom: 3px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
.form-search,
.v-input {
  width: 800px;
  height: 43px;
  border-radius: 100px;
  font-size: 12px;
  color: #999999;
  font-weight: 400;
}

.pointer {
  cursor: pointer;
}

.email-label {
  cursor: pointer;
  height: 100%;
}

.bg-dark {
  background-color: var(--v-neutral-darken2);
}

.toolbar__initials--text {
  font-size: 12px;
}

html body .always-active-list-item {
  height: 40px;
}

html body .always-active-list-item .v-list-item__icon {
  margin: 0px;
  align-self: auto;
}

html body .always-active-list-item.v-list-item--link:before {
  color: varFigma(neutral-99);
  opacity: 1 !important;
}

html
  body
  .always-active-list-item.v-list-item--link:not(.activeToolbarBorder):hover::before {
  background-color: varFigma(brand-99-lightest);
  border: 1px solid varFigma(brand-80-light);
}

html body .always-active-list-item--dark.v-list-item--link:before {
  color: varFigma(neutral-99);
}

html body .always-active-list-item--dark.v-list-item--link .v-list-item__title {
  color: #f8f8ff;
  z-index: 1;
}

html
  body
  .always-active-list-item--dark.v-list-item--link
  .v-list-item__icon
  * {
  color: var(--v-blueMarine-base);
}

html body .always-active-list-item.v-list-item--link * {
  color: var(--v-primary-base);
}

.bordered-toolbar {
  border-bottom: 1px solid #e6e8f8;
}

.avatar-floating-skeleton-loader {
  height: 40px;
  position: absolute;
  left: 10px;
  background: transparent;
  top: 0px;
  margin-left: -2px;
}
</style>

<style lang="scss">
html
  .avatar-floating-skeleton-loader--mobile
  .v-skeleton-loader__list-item-avatar.v-skeleton-loader__bone {
  background: transparent !important;
  padding: 0px;
  height: 24px;
}

html
  .avatar-floating-skeleton-loader
  .v-skeleton-loader__list-item-avatar.v-skeleton-loader__bone {
  background: transparent;
  padding: 0px;
}

.avatar-floating-skeleton-loader--mobile
  .v-skeleton-loader__list-item-avatar.v-skeleton-loader__bone
  * {
  margin-right: 0px !important;
}

.avatar-floating-skeleton-loader
  .v-skeleton-loader__avatar.v-skeleton-loader__bone {
  width: 24px;
  height: 24px;
  margin-right: 0 !important;
}

.v-application--is-ltr
  .v-skeleton-loader__list-item-avatar
  .avatar-floating-skeleton-loader
  .v-skeleton-loader__avatar {
  margin-right: 0 !important;
}

.avatar-floating-skeleton-loader--mobile
  .v-skeleton-loader__avatar.v-skeleton-loader__bone {
  width: 24px;
  height: 24px;
}

.toolbar__initials--text {
  font-size: 12px;
}

html body .always-active-list-item {
  height: 40px;
}

.v-list-item.always-active-list-item {
  min-height: 40px !important;
  height: 40px !important;
}

html body .always-active-list-item .v-list-item__icon {
  margin: 0px;
  align-self: auto;
}

html body .always-active-list-item.v-list-item--link:before {
  color: var(--v-primary-base);
  opacity: 0.12 !important;
}

html body .always-active-list-item--dark.v-list-item--link:before {
  color: #373b54;
  opacity: 1 !important;
}

html body .always-active-list-item--dark.v-list-item--link .v-list-item__title {
  color: #f8f8ff;
  z-index: 1;
}

html
  body
  .always-active-list-item--dark.v-list-item--link
  .v-list-item__icon
  * {
  color: var(--v-blueMarine-base);
}

html body .always-active-list-item.v-list-item--link * {
  color: var(--v-primary-base);
}

.global__currentRoute-title {
  color: varFigma(neutral-20-dark);
  font-weight: 500;
  font-size: 18px;
}

.toolbarMenuIcon {
  color: varFigma(neutral-70) !important;
}

.bordered-toolbar {
  border-bottom: 1px solid #e6e8f8;
}
.userNameText {
  color: #3f404c;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%; /* 21px */
}
.roleText {
  color: #282931;
  font-size: 12px;
  font-weight: 400;
}
.emailSubtitleText {
  color: #636578;
  font-size: 12px;
  font-weight: 400;
}
.avatarText {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
}
.profileBtn {
  font-size: 12px;
  font-weight: 500;
  line-height: 150%; /* 18px */
}
.v-list .smallItem {
  max-height: 44px !important;
}
.activeToolbarBorder {
  border-radius: 4px;
  border: 2px solid #3f55ee;
}
.icon-white {
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%)
    contrast(100%) !important;
}
.container-ellipsis {
  width: 200px; /* Optional: Define the container width */
}

.ellipsis-text {
  display: inline-block;
  max-width: 200px; /* Limit the width to 200px */
  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Show ellipsis when text overflows */
}
</style>
